<template>
    <Html>
        <Body class="overflow-x-hidden antialiased">
            <NuxtLayout :name="layout">
                <NuxtLoadingIndicator
                    :height="5"
                    :duration="3000"
                    :throttle="400"
                />
                <NuxtPage />
            </NuxtLayout>
        </Body>
    </Html>
</template>
<script setup>
import { onMounted } from 'vue'
import { initFlowbite } from 'flowbite'
import { storeToRefs } from 'pinia'
import { useGamesGoStore } from '~/stores'
import { OK } from '~/constants/apiStatus'

const { locale, t } = useI18n()

const langstate = useState('langstate')
locale.value = langstate.value

const brandName = useRuntimeConfig().public.BRAND_NAME
const baseurl = useRuntimeConfig().public.BASE_URL

const fetcher = useCustomFetch()
const useGamesGoStoreInstance = useGamesGoStore()
const { bannerGo } = storeToRefs(useGamesGoStoreInstance)

const layout = 'default'

onMounted(() => {
    initFlowbite()
})
useSeoMeta({
    description: brandName,
    ogTitle: brandName,
    ogDescription: brandName,
    ogImage: '/assets/favicon.png?v=1',
    twitterTitle: brandName,
    twitterDescription: brandName,
    twitterImage: '/assets/favicon.png?v=1',
    twitterCard: brandName,
})

useJsonld([
    {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: baseurl,
        contactPoint: [
            {
                '@type': 'ContactPoint',
                telephone: t('contact-phone'),
                contactType: 'customer service',
            },
        ],
    },

    {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: baseurl,
        logo: `${baseurl}/assets/logo.svg`,
    },
    {
        '@context': 'https://schema.org/',
        '@type': 'Game',
        name: brandName,
        description: t('best_online_gambling'),
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '94',
            bestRating: '100',
            ratingCount: '130',
        },
    },
])

useHead({
    meta: [
        {
            name: 'viewport',
            content:
                'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
        },
    ],
    htmlAttrs: {
        lang: 'vi',
    },
    link: [
        {
            rel: 'stylesheet',
            href: 'https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap',
        },
    ],
})

await useAsyncData(
    'bannerGo',
    async () => {
        try {
            if (bannerGo.value.length) return bannerGo.value

            const { data } = await fetcher.get('/live/jackpot')
            const isSuccessful =
                data.value?.status === OK && data.value?.code === 200

            if (isSuccessful) {
                useGamesGoStoreInstance.syncGameOn(data.value.data)
            }

            return bannerGo.value
        } catch (error) {
            console.error('Error fetching jackpot data', error)

            throw error
        }
    },
    {
        default: () => [],
    }
)
</script>
<style lang="scss">
@import url('./assets/scss/main.scss');
.page-enter-active,
.page-leave-active {
    transition: all 0.2s;
}

.page-enter-from,
.page-leave-to {
    opacity: 0;
    filter: blur(2px);
}

.page-body-account {
    overflow-x: hidden;
}
</style>
